import { getElementsByClassName } from './utils';
import { parseHandString } from './mahjong/parseHandString';
import { renderTiles } from './mahjong/renderTiles';
import { detectMelds } from './mahjong/utils';
import jsx from './jsx';

const renderAndLogSorted = (input: string, output: HTMLDivElement) => {
  const parsedHand = parseHandString(input);
  renderTiles(parsedHand, output);

  const sortedHand = detectMelds(parsedHand);
  console.log(sortedHand);
};

document.addEventListener('DOMContentLoaded', async () => {
  const hands = getElementsByClassName<HTMLDivElement>('mpszhand');

  hands?.forEach((hand) => {
    renderTiles(parseHandString(hand.innerText), hand);
  });

  const demo = getElementsByClassName<HTMLDivElement>('mpszdemo')?.[0];
  if (demo) {
    demo.innerHTML = '';

    const output = (<div className="mpszhand"></div>) as HTMLDivElement;

    const input = (
      <input
        placeholder="MPSZ notation"
        value="340s678s111z50m-55'0p"
        oninput={(event: Event) => {
          const inputTarget = event.target as HTMLInputElement;

          renderAndLogSorted(inputTarget.value, output);
        }}
        style="margin-bottom: 12px"
      />
    ) as HTMLInputElement;

    demo.append(input);
    demo.append(output);

    renderAndLogSorted((input as HTMLInputElement).value, output);
  }
});
